import React from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import PageHeader from "../../components/PageHeader";
import DataComponent from "../../components/DataComponent";

const TestBadges = (props) => {
  return (
    <div className="test-page">
      <PageHeader title="WeCake - Badge" />

      <Card>
        <CardBody>
          <CardTitle>Badge Style</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            Badge color
          </CardSubtitle>
          <br />

          <div className="badge-items">
            <DataComponent field={{
              type: "badge",
              color: "primary",
              label: "Primary",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "secondary",
              label: "Secondary",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "danger",
              label: "danger",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "success",
              label: "success",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "warning",
              label: "warning",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "info",
              label: "info",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "light",
              label: "light",
            }}
            />
            <DataComponent field={{
              type: "badge",
              color: "dark",
              label: "dark",
            }}
            />
          </div>
          <br />
          <br />
          <br />
          <CardSubtitle className="mb-3">
            Badge Size
          </CardSubtitle>
          <br />

          <div className="badge-items">
            <DataComponent field={{
              type: "badge",
              label: "large",
              size: "lg"
            }}
            />
            <DataComponent field={{
              type: "badge",
              label: "medium",
              size: "md"
            }}
            />
            <DataComponent field={{
              type: "badge",
              label: "small",
              size: "sm"
            }}
            />
          </div>


        </CardBody>
      </Card>


    </div>
  );
};

export default TestBadges;
